<template>
  <div>
    <!-- 平台 -->
    <el-select
      class="margin-left-10"
      v-model="query.bizChannel"
      :size="size"
      @change="handleBizChannelChange"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        v-for="item in bizChannelList"
        :key="item.key"
        :label="item.name"
        :value="item.key"
      ></el-option>
    </el-select>
    <!-- 应用 || 服务名称 -->
    <el-select
      :style="{width: '180px'}"
      class="margin-left-10"
      :size="size"
      :key="sourceList.length"
      v-model="query.source"
      placeholder="请选择"
      filterable
      @change="handleSourceChange"
    >
      <el-option label="全部" value=""></el-option>
      <el-option
        v-for="item in sourceList"
        :key="item.key"
        :label="item.name"
        :value="item.key"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
} from 'vuex';

export default {
  props: {
    isAutoSelect: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  data() {
    return {
      sourceList: [],
      query: {
        source: '',
        bizChannel: '',
      },
    };
  },
  computed: {
    ...mapGetters(
      'app',
      [
        'bizChannelList',
      ],
    ),
  },
  watch: {},
  created() {},
  mounted() {
    if (this.isAutoSelect) {
      this.handleBizChannelChange(this.bizChannelList[0].key, true);
      // this.setSource('');
    } else {
      this.setBizChannel('');
      this.setSource('');
    }
  },
  methods: {
    ...mapActions(
      'app',
      ['setSource', 'setBizChannel'],
    ),
    /**
     * 平台切换
     */
    handleBizChannelChange(value, isAutoSelectSource = false) {
      const items = this.bizChannelList.find((item) => item.key === value);

      this.query.source = '';
      this.sourceList.splice(0);
      this.sourceList.push(...items?.sources || []);

      this.setSource(isAutoSelectSource ? this.sourceList[0].key : '');
      this.query.source = isAutoSelectSource ? this.sourceList[0].key : '';
      this.query.bizChannel = value;
      this.setBizChannel(value);
    },
    // 应用切换
    handleSourceChange(value) {
      this.setSource(value);
    },
  },
};
</script>
